@if (notifications$ | async; as notifications) {
  <div
    class="d-flex align-items-center dropdown notifications-center"
    bsDropdown
    [insideClick]="true"
    [isOpen]="isOpen"
    (isOpenChange)="onDropdownOpen($event)"
    placement="bottom right"
  >
    <div
      class="d-flex align-items-center clickable"
      dropdownToggle
      [ngClass]="{ hasNotifications: !!notifications.length }"
    >
      <i class="icon icon-notifications-circle">
        <div>
          <span class="count-of-notifications">{{ notifications.length ? notifications.length : undefined }}</span>
        </div>
      </i>
    </div>
    <div *dropdownMenu class="dropdown-menu dropdown-menu-right mt-0" role="menu">
      <div class="d-flex align-items-center justify-content-between px-4 py-3 mt-n2">
        <div data-locator="title" class="body semibold">Items ({{ notifications.length }})</div>
        <button
          type="button"
          [disabled]="!notifications.length"
          (click)="handleDeleteAll()"
          data-locator="deleteAll"
          class="btn btn-link semibold"
        >
          Delete all
        </button>
      </div>
      @if (notifications.length) {
        <div class="notifications body">
          @for (notification of notifications; track trackById($index, notification)) {
            @if (!notification.deleted) {
              <gcc-notification-item
                [notification]="notification"
                (delete)="handleDelete($event)"
                (detailsOpen)="onDropdownOpen(false)"
                data-locator="item"
              >
              </gcc-notification-item>
            }
            @if (notification.deleted) {
              <div
                data-locator="item-undo"
                class="notification-deleted background-lighter align-items-center d-flex caption"
              >
                <p class="mr-2">
                  Your {{ notificationType[notification.type].toLowerCase() }} was successfully deleted
                </p>
                <button type="button" class="btn btn-link" (click)="handleCancelDelete(notification.notificationId)">
                  Undo
                </button>
              </div>
            }
          }
        </div>
      }
      @if (!notifications.length) {
        <div data-locator="empty" class="text-center">
          <img
            class="mb-2"
            src="../../../../../assets/images/empty/ill-no-notifications.svg"
            alt="No alerts and notification"
          />
          <div class="p-4 mb-4 semibold">No alerts and notification for you yet</div>
        </div>
      }
    </div>
  </div>
}
